import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Box, flameTheme } from '@lightspeed/flame/Core';
import { Heading2, Text, TextLink } from '@lightspeed/flame/Text';

import { toBoolean } from 'root/apps/pages/utils/sanitize';
import { OverviewDataContext } from 'root/apps/PurchaseOrder/ShipmentHistory/tabs/View/contexts/OverviewData';

const Header: React.FC = () => {
  const { colors } = flameTheme;
  const { data: overviewData, isInitialLoading: isOverviewInitialLoading } =
    React.useContext(OverviewDataContext);

  const [hasEmployeePermission] = React.useState<boolean | null>(
    toBoolean(window.merchantos.session.sessData?.Rights?.admin_employees)
  );

  const employeeLink =
    overviewData && hasEmployeePermission
      ? `?name=admin.views.employee&form_name=view&id=${overviewData.employeeID}&tab=details`
      : '';

  const employeNameOrEmail = overviewData?.receivedBy.trim() || overviewData?.employeeEmail;

  return !isOverviewInitialLoading ? (
    <>
      <Heading2 py={0}>
        Record of shipment for PO{' '}
        {overviewData ? (
          <var>
            #{overviewData.orderID}-{overviewData.sequenceNumber}
          </var>
        ) : null}
      </Heading2>

      {employeNameOrEmail ? (
        <Box>
          <Text as="span" color={colors.textDimmed}>
            Last modified by:&nbsp;
          </Text>
          {employeeLink ? (
            <TextLink
              data-test="shipment-employee-link"
              fontWeight="bold"
              className="notranslate"
              href={employeeLink}
              onClick={(e) => {
                e.preventDefault();
                window.navigateToContent(
                  'view',
                  'admin.views.employee',
                  overviewData?.employeeID,
                  'details'
                );
              }}
            >
              {employeNameOrEmail}
            </TextLink>
          ) : (
            <Text as="span" className="notranslate" data-test="shipment-employee-text">
              {employeNameOrEmail}
            </Text>
          )}
        </Box>
      ) : null}
    </>
  ) : (
    <Box>
      <Bone height={4} width="30%" />
    </Box>
  );
};

export default Header;
